import { render, staticRenderFns } from "./GravatarChooser.vue?vue&type=template&id=d5c05af0&scoped=true"
import script from "./GravatarChooser.vue?vue&type=script&lang=js"
export * from "./GravatarChooser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c05af0",
  null
  
)

export default component.exports